module.exports = __webpack_public_path__ + "img/begin.cd0c9590.svg";